module.exports = __webpack_public_path__ + "static/media/Yashweb2.2ad0d157.png";